module.exports = __webpack_public_path__ + "media/honey-icons/icon-cupboard-f4c2664f.svg";